import toast from "react-hot-toast";
import { formatDateDb } from "../../utils/tools";
import { StatusData } from "../../utils/globalVariable";
import { customDateFormatType } from "../../utils/utils";

const formatStatus = (status) => {
  switch (status) {
    case "NEW":
      return "Mới";
    case "REJECTED":
      return "Từ chối";
    case "APPROVED":
      return "Đã duyệt";
    case "REFUND":
      return "Hoàn trả";
    case "EDITING":
      return "Yêu cầu chỉnh sửa";
    default:
      return "";
  }
};

const { clientAPI } = require("../client");
export const contractCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/salesContract", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/salesContract/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approve: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/salesContract/approve/${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  revert: async (id) => {
    try {
      const response = await clientAPI("put", `/salesContract/revert/${id}`);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateHiddenStatus: async (id) => {
    try {
      const response = await clientAPI(
        "put",
        `/salesContract/updateHiddenStatus/${id}`,
      );
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  export: async (entries, param) => {
    try {
      const options = {
        limit: entries,
        page: 1,
      };

      if (param.search) options.search = param.search;
      if (param.employeeId) options.employeeId = param.employeeId;
      if (param.projectId) options.projectId = param.projectId;

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/salesContract?${queryParams}`);

      const dataExport = response?.items.map((item, index) => {
        let statusData = "";

        if (item?.status === StatusData.hdmb.APPROVED) {
          statusData = "Đã được duyệt";
        } else if (item?.status === StatusData.hdmb.REJECTED) {
          statusData = "Không được phê duyệt";
        } else {
          statusData = "Đã chờ phê duyệt";
        }

        return {
          status: statusData || "",
          code: item?.code || "",
          ttkq: item?.ttkq?.code || "",
          locking: item?.locking?.code || "",
          project: item?.project?.name || "",
          apartment: item?.locking?.apartmentObject?.code || "",
          nameApartment: item?.locking?.apartmentObject?.name || "",
          customer: item?.customerObject?.name || "",
          time: item?.time ? formatDateDb(item?.time) : "",
          // invoice: item?.invoice || "-",
          paymentMethod: item?.paymentMethod?.name || "",
          creator: item?.creatorObject?.fullName || "",
          approver: item?.approver?.fullName || "",
          saleBlock: item?.creator?.saleBlock?.name || "-",
          saleArea: item?.creator?.saleArea?.name || "-",
          createdAt: item?.createdAt ? formatDateDb(item?.createdAt) : "",
        };
      });

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  exportV2: async (param) => {
    try {
      const options = {};

      if (param?.startDate)
        options.startTime = customDateFormatType(param.startDate);
      if (param?.endDate) options.endTime = customDateFormatType(param.endDate);

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI(
        "get",
        `/salesContract/exportTransaction?${queryParams}`,
      );

      const bookingItems = response?.bookingItems?.items || [];
      const lockingItems = response?.lockingItems?.items || [];

      const bookingData = bookingItems.map((item) => {
        return {
          code: item?.code || "",
          projectCode:
            item?.project?.code ||
            item?.locking?.project?.code ||
            item?.locking?.ttkq?.project?.code ||
            item?.locking?.salesContract?.project?.code ||
            item?.locking?.ttkq?.salesContract?.project?.code ||
            "",
          saleOpeningEventCode: item?.locking?.saleOpeningEvent?.code || "",
          apartmentCode:
            item?.apartment?.code || item?.locking?.apartment?.code || "",
          customer: item?.customer?.phone || "",
          creatorCode: item?.booker?.code || "",
          saleBlock: item?.attendance?.saleBlock?.name || "",
          saleBlockManagerCode: item?.attendance?.saleBlockManager?.code || "",
          saleArea: item?.attendance?.saleArea?.name || "",
          saleAreaManagerCode: item?.attendance?.saleAreaManager?.code || "",
          branch: item?.attendance?.branch?.name || "",
          saleBranchManagerCode:
            item?.attendance?.saleBranchManager?.code || "",

          statusBooking: formatStatus(item?.status || ""),
          priceBooking: item?.price || "",
          timeBooking: item?.bookingTime ? formatDateDb(item?.bookingTime) : "",
          PaymentMethodBooking: "",
          additionalInformationBooking: "",
          noteBooking: item?.note || "",
          employeeCodeApproveBooking:
            item?.bookingHistory?.approver?.code || "",
          timeApproveBooking: item?.bookingHistory?.createdAt
            ? formatDateDb(item?.bookingHistory?.createdAt)
            : "",

          statusLocking: formatStatus(item?.locking?.status || ""),
          priceLocking: item?.locking?.price || "",
          timeLocking: item?.locking?.bookingTime
            ? formatDateDb(item?.locking?.bookingTime)
            : "",
          PaymentMethodLocking: item?.locking?.paymentMethod?.name || "",
          additionalInformationLocking: "",
          noteLocking: item?.locking?.note || "",
          employeeCodeApproveLocking:
            item?.locking?.lockingHistory?.approver?.code || "",
          timeApproveLocking: item?.locking?.lockingHistory?.createdAt
            ? formatDateDb(item?.locking?.lockingHistory?.createdAt)
            : "",

          statusTtkq: formatStatus(item?.locking?.ttkq?.status || ""),
          priceTtkq: item?.locking?.ttkq?.price || "",
          timeTtkq: item?.locking?.ttkq?.priceTime
            ? formatDateDb(item?.locking?.ttkq?.priceTime)
            : "",
          PaymentMethodTtkq: item?.locking?.ttkq?.paymentMethod?.name || "",
          additionalInformationTtkq: "",
          noteTtkq: item?.locking?.ttkq?.note || "",
          employeeCodeApproveTtkq: item?.locking?.ttkq?.approver?.code || "",
          timeApproveTtkq: item?.locking?.ttkq?.approverDate
            ? formatDateDb(item?.locking?.ttkq?.approverDate)
            : "",

          statusHdmb: formatStatus(
            item?.locking?.salesContract?.status ||
              item?.locking?.ttkq?.salesContract?.status ||
              "",
          ),
          priceHdmb:
            item?.locking?.salesContract?.price ||
            item?.locking?.ttkq?.salesContract?.price ||
            "",
          timeHdmb: item?.locking?.salesContract?.priceTime
            ? formatDateDb(item?.locking?.salesContract?.priceTime)
            : item?.locking?.ttkq?.salesContract?.priceTime
              ? formatDateDb(item?.locking?.ttkq?.salesContract?.priceTime)
              : "",
          PaymentMethodHdmb:
            item?.locking?.salesContract?.paymentMethod?.name ||
            item?.locking?.ttkq?.salesContract?.paymentMethod?.name ||
            "",
          additionalInformationHdmb: "",
          noteHdmb:
            item?.locking?.salesContract?.note ||
            item?.locking?.ttkq?.salesContract?.note ||
            "",
          employeeCodeApproveHdmb:
            item?.locking?.salesContract?.approver?.code || "",
          timeApproveHdmb: item?.locking?.salesContract?.approverDate
            ? formatDateDb(item?.locking?.salesContract?.approverDate)
            : "",

          inputLate: item?.locking?.inputLate ? "Muộn" : "Không muộn",
          isWrongInput: item?.locking?.isWrongInput ? "Sai" : "Không sai",
        };
      });

      const lockingData = lockingItems.map((item) => {
        return {
          code: item?.code || "",
          projectCode:
            item?.project?.code ||
            item?.booking?.project?.code ||
            item?.ttkq?.project?.code ||
            item?.salesContract?.project?.code ||
            item?.ttkq?.salesContract?.project?.code ||
            "",
          saleOpeningEventCode: item?.saleOpeningEvent?.code || "",
          apartmentCode: item?.apartment?.code || item?.booking?.apartment?.code  ||  "",
          customer: item?.customer?.phone || "",
          creatorCode: item?.booker?.code || "",
          saleBlock: item?.attendance?.saleBlock?.name || "",
          saleBlockManagerCode: item?.attendance?.saleBlockManager?.code || "",
          saleArea: item?.attendance?.saleArea?.name || "",
          saleAreaManagerCode: item?.attendance?.saleAreaManager?.code || "",
          branch: item?.attendance?.branch?.name || "",
          saleBranchManagerCode:
            item?.attendance?.saleBranchManager?.code || "",

          statusBooking: formatStatus(item?.booking?.status || ""),
          priceBooking: item?.booking?.price || "",
          timeBooking: item?.booking?.bookingTime
            ? formatDateDb(item?.booking?.bookingTime)
            : "",
          PaymentMethodBooking: "",
          additionalInformationBooking: "",
          noteBooking: item?.booking?.note || "",
          employeeCodeApproveBooking:
            item?.booking?.bookingHistory?.approver?.code || "",
          timeApproveBooking: item?.booking?.bookingHistory?.createdAt
            ? formatDateDb(item?.booking?.bookingHistory?.createdAt)
            : "",

          statusLocking: formatStatus(item?.status || ""),
          priceLocking: item?.price || "",
          timeLocking: item?.bookingTime ? formatDateDb(item?.bookingTime) : "",
          PaymentMethodLocking: item?.paymentMethod?.name || "",
          additionalInformationLocking: "",
          noteLocking: item?.note || "",
          employeeCodeApproveLocking:
            item?.lockingHistory?.approver?.code || "",
          timeApproveLocking: item?.lockingHistory?.createdAt
            ? formatDateDb(item?.lockingHistory?.createdAt)
            : "",

          statusTtkq: formatStatus(item?.ttkq?.status || ""),
          priceTtkq: item?.ttkq?.price || "",
          timeTtkq: item?.ttkq?.priceTime
            ? formatDateDb(item?.ttkq?.priceTime)
            : "",
          PaymentMethodTtkq: item?.ttkq?.paymentMethod?.name || "",
          additionalInformationTtkq: "",
          noteTtkq: item?.ttkq?.note || "",
          employeeCodeApproveTtkq: item?.ttkq?.approver?.code || "",
          timeApproveTtkq: item?.ttkq?.approverDate
            ? formatDateDb(item?.ttkq?.approverDate)
            : "",

          statusHdmb: formatStatus(
            item?.salesContract?.status ||
              item?.ttkq?.salesContract?.status ||
              "",
          ),
          priceHdmb:
            item?.salesContract?.price ||
            item?.ttkq?.salesContract?.price ||
            "",
          timeHdmb: item?.salesContract?.priceTime
            ? formatDateDb(item?.salesContract?.priceTime)
            : item?.ttkq?.salesContract?.priceTime
              ? formatDateDb(item?.ttkq?.salesContract?.priceTime)
              : "",
          PaymentMethodHdmb:
            item?.salesContract?.paymentMethod?.name ||
            item?.ttkq?.salesContract?.paymentMethod?.name ||
            "",
          additionalInformationHdmb: "",
          noteHdmb:
            item?.salesContract?.note || item?.ttkq?.salesContract?.note || "",
          employeeCodeApproveHdmb: item?.salesContract?.approver?.code || "",
          timeApproveHdmb: item?.salesContract?.approverDate
            ? formatDateDb(item?.salesContract?.approverDate)
            : "",

          inputLate: item?.inputLate ? "Muộn" : "Không muộn",
          isWrongInput: item?.isWrongInput ? "Sai" : "Không sai",
        };
      });

      const dataExport = [...bookingData, ...lockingData].filter((row) =>
        Object.values(row).some(
          (value) => value !== "" && value !== null && value !== undefined,
        ),
      );

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);

      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });

      throw error;
    }
  },
  bulkImport: async (data) => {
    try {
      const response = await clientAPI(
        "post",
        "/salesContract/bulkImport/",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  transfer: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/salesContract/app/transfer/${id}`,
        data,
      );
      return response;
    } catch (error) {
      console.error("transfer error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getTypeImage: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/salesContract/getTypeImage/${id}`,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  downloadPDF: async (id, payload) => {
    try {
      const response = await clientAPI(
        "put",
        `/salesContract/downloadPDF/${id}`,
        payload,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
